import { useMutation } from "@tanstack/react-query";
import { Api, type UpdateUserEmailRequest } from "@/api";
import { usersKeys } from "./keys";

type UpdateUserEmailInput = UpdateUserEmailRequest & { id: string };

/** Меняет почту пользователя из админки. */
export const useUpdateUserEmail = () => {
	const mutation = useMutation({
		mutationFn: ({ id, email }: UpdateUserEmailInput) =>
			Api.User.putApiUsersEmailById({ id }, { email }),
		mutationKey: usersKeys.updateEmail,
	});
	return { execute: mutation.mutateAsync, isPending: mutation.isPending };
};
